import {useQuery} from "@tanstack/react-query"
import {API} from "config"

const useBlackBnfReportListBnf100 = (term = null) => useQuery({
    queryKey: ['black-bnf-bnf-100', term], queryFn: async () => {
        const callback = await API.get(`/black-bnf/bnf-100${term ? `&term=${term}` : ''}`)
        return callback?.data
    }
})

export default useBlackBnfReportListBnf100